(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasis-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  // Oasis UGC gallery: arrows + gentle auto-advance.
  // Auto-advance pauses on any interaction and never runs for
  // users who prefer reduced motion.
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initGallery(stage) {
      if (stage.dataset.oasisUgcBound) return;
      stage.dataset.oasisUgcBound = '1';

      var track = stage.querySelector('[data-ugc-track]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.oasis-ugc__card');
        if (!card) return 220;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
        return card.offsetWidth + gap;
      }

      function scrollByCards(dir) {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (dir > 0 && track.scrollLeft >= maxScroll - 5) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (dir < 0 && track.scrollLeft <= 5) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step() * dir, behavior: 'smooth' });
        }
      }

      var prev = stage.querySelector('[data-ugc-prev]');
      var next = stage.querySelector('[data-ugc-next]');
      if (prev) prev.addEventListener('click', function () { pause(); scrollByCards(-1); });
      if (next) next.addEventListener('click', function () { pause(); scrollByCards(1); });

      // --- Auto-advance ---
      var speed = parseFloat(stage.dataset.autoplay);
      if (REDUCE || !speed) return;

      var timer = null;
      var resumeTimer = null;

      function play() {
        clearInterval(timer);
        timer = setInterval(function () {
          if (document.hidden) return;
          scrollByCards(1);
        }, speed * 1000);
      }

      function pause() {
        clearInterval(timer);
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(play, 7000);
      }

      ['touchstart', 'mousedown', 'wheel', 'keydown'].forEach(function (evt) {
        track.addEventListener(evt, pause, { passive: true });
      });
      stage.addEventListener('mouseenter', function () { clearInterval(timer); });
      stage.addEventListener('mouseleave', function () { clearTimeout(resumeTimer); play(); });

      // Only start once it's actually on screen.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { play(); } else { clearInterval(timer); }
          });
        }, { threshold: 0.3 });
        io.observe(stage);
      } else {
        play();
      }
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-oasis-ugc]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();
})();
